function GoogleMap() {
	this.build();
}

GoogleMap.prototype.build = function () {
	var map = $('#map');
	if (map.length) {
		var lat = map.data('lat');
		var lng = map.data('lng');
		var title = map.data('title');
		var zoom = map.data('zoom');

		var mapStyle =
			[
				{
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#bdbdbd"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dadada"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c9c9c9"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				}
			];

		// Single agences
		if (lat && lng) {
			var map_agency = new google.maps.Map(document.getElementById("map"), {
				center: new google.maps.LatLng(lat, lng),
				zoom: zoom,
				styles: mapStyle,
				mapTypeControl: false,
				scrollwheel: false,
				fullscreenControl: true,

			});

			let summer = document.querySelector('.mode-summer');

			let mapPin = mcubeArgs.themeLink + "/svg/map-pin.svg";
			if (summer) {
				mapPin = mcubeArgs.themeLink + "/svg/map-pin-summer.svg";
			}
			var infoWindow = new google.maps.InfoWindow({
				content: title
			});

			var marker = new google.maps.Marker({
				position: {lat: parseFloat(lat), lng: parseFloat(lng)},
				map: map_agency,
				title: title,
				icon: {
					url: mapPin,
					scaledSize: new google.maps.Size(24, 30)
				}
			});

			google.maps.event.addListener(marker, 'click', function () {
				infoWindow.open(map_agency, marker);
			});


			document.querySelectorAll(".google-maps-pointers .google-maps-pointer").forEach(item => {
				var infoWindow = new google.maps.InfoWindow({
					content: item.dataset.pointerTitle
				});
				var marker = new google.maps.Marker({
					position: {lat: parseFloat(item.dataset.lat), lng: parseFloat(item.dataset.lng)},
					map: map_agency,
					title: item.dataset.pointerTitle,
					icon: {
						url: mapPin,
						scaledSize: new google.maps.Size(24, 30)
					}
				});

				google.maps.event.addListener(marker, 'click', function () {
					infoWindow.open(map_agency, marker);
				});
			});
		}
	}
};
